import * as React from 'react';
import AppBadges from './AppBadges';
import MinglVideo from './MinglVideo';
import MinglAppLogo from '../../../ui/MinglAppLogo';

export default function VideoPromotion() {
  return (
    <section
      className="ph5-ns ph4 pv6"
      style={{
        backgroundColor: '#0f4c63',
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='6' height='6' viewBox='0 0 6 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23000000' fill-opacity='0.21' fill-rule='evenodd'%3E%3Cpath d='M5 0h1L0 6V5zM6 5v1H5z'/%3E%3C/g%3E%3C/svg%3E")`,
      }}
    >
      <div className="flex justify-around items-center flex-row-l flex-column-m flex-column">
        <MinglVideo />
        <section style={{ flexBasis: '40%' }}>
          <MinglAppLogo width="100px" />
          <div className="mw6">
            <h2 className="white">Quick. Easy. Powerful.</h2>
            <p className="white fw3 lh-copy tj">
              Using Mingl is simple. Fill in the contact info you want to share,
              and you get your own QR code that is ready to share (it can be
              scanned by all smartphones). That’s it! When you scan other users
              they are saved in your feed so that you can easily find their
              contact information when you need it.
            </p>
            {AppBadges()}
          </div>
        </section>
      </div>
    </section>
  );
}
